import type { BenefitsUsagePageDataCollectionQuery } from 'generated/resources/graphql'

import type { EmployeeSpendingData } from './types'

export function extractEmployeeData(
  data: BenefitsUsagePageDataCollectionQuery
): EmployeeSpendingData[] {
  return data.employees.employeeNamesConnection.nodes.map((e) => {
    const consolidatedAmounts = e.benefitCompensationsConnection.nodes.reduce(
      (acc, compensation) => {
        return {
          ...acc,
          [compensation.category]: compensation.amountCents,
        }
      },
      {
        meals: 0,
        transportation: 0,
        childcare: 0,
        unsupported: 0,
      }
    )

    return {
      ...e,
      amounts: consolidatedAmounts,
    }
  })
}
